import dateFormat from 'dateformat';

const fullDateFormat = (date: Date | string) => dateFormat(date, 'yyyy-mm-dd');

export default fullDateFormat;
